import {get, post} from '../interceptor'

let preUrl = '/energyMonitor';
export default {

  getAlarmNum (params) { return post(preUrl, '/getAlarmNum', params) },
  getDataType (params) { return post(preUrl, '/getDataType?mediaId=' + params) },
  getMonitorDataType (params) { return post(preUrl, '/getMonitorDataType?mediaId=' + params) },
  getQualityDataType (params) { return post(preUrl, '/getQualityDataType?' + params) },
  getTransferDataType (params) { return post(preUrl, '/getTransferDataType?transId=' + params) },
  getAllSensorParam (params) { return post(preUrl, '/getAllSensorParam', params) },
  getAlarmInfo (params) { return post(preUrl, '/getAlarmInfo', params) },
  updateAlarmStatus (params) { return post(preUrl, '/updateAlarmStatus', params) },
  getLimitInfo (params) { return post(preUrl, '/getLimitInfo', params) },
  addLimitInfo (params) { return post(preUrl, '/addLimitInfo', params) },
  updateLimitInfo (params) { return post(preUrl, '/updateLimitInfo', params) },
  deleteLimitInfo (params) { return post(preUrl, '/deleteLimitInfo', params) },
  getNoticeInfo (params) { return get(preUrl, '/getNoticeInfo?userId=' + params) },
  updateNoticeInfo (params) { return post(preUrl, '/updateNoticeInfo', params) },
  getAlarmById (params) { return post(preUrl, '/getAlarmById', params) },
  getRecentAlarm (params) { return get(preUrl, '/getRecentAlarm?noticeNum=' + params) },
  // 变压器监测
  getTransferInfo(params) { return post(preUrl, "/getTransferInfo", params) },
  getTransferData(params) { return post(preUrl, "/getTransferData", params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/energyMonitor.js